/**
 * @generated SignedSource<<54cf11071c9c9313e11dd78d06ba3d4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllPhasesDropdown_phases$data = ReadonlyArray<{
  readonly node: {
    readonly id: string;
    readonly name: string | null;
    readonly projectId: string | null;
  } | null;
  readonly " $fragmentType": "AllPhasesDropdown_phases";
}>;
export type AllPhasesDropdown_phases$key = ReadonlyArray<{
  readonly " $data"?: AllPhasesDropdown_phases$data;
  readonly " $fragmentSpreads": FragmentRefs<"AllPhasesDropdown_phases">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AllPhasesDropdown_phases",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhaseTypeEdge",
  "abstractKey": null
};

(node as any).hash = "3395666153959a186fca1718aeed5341";

export default node;
